/*  THE DECK. Steps between folders instead of stacking them down the page.

    TABS ONLY. Arrows were built and cut: they say there is more without saying how much
    or what, and they force somebody who wants the drums to step past the phrases. The
    named tabs do that job and the map at the same time. Keyboard and swipe still move
    one step at a time, because those are gestures rather than controls and there is no
    tab row under a thumb mid drag.

    THE SCRIPT ADDS is-live, and the stylesheet keys the whole slide behaviour off that
    class. Until this file runs the deck is an ordinary horizontal snap scroller, so a
    failed script leaves a page that still works rather than one panel and nothing else.

    IT DOES NOT WRAP. Four folders is a list, not a carousel of offers, and a list that
    silently returns to the start hides the fact that you reached the end.

    PLAYBACK STOPS WHEN A FOLDER LEAVES. Otherwise a preview keeps playing from a panel
    that is no longer on screen and there is nothing to press to stop it.

    A FOLDER CAN CARRY ITS OWN COLOUR, and on the bundle every one does. The four kits
    have four sleeves and four accents, so a deck that shows all of them in one teal was
    the one place on the site where the colour stopped meaning anything. A tab with
    data-tint writes that colour onto the SECTION'S OWN .ev-kit wrapper, which is where
    ev-kit-neutral.css derives the hairlines and where ev-kit-audio.js reads the waveform
    colour from. One property, and the tabs, numerals, rows, rules, glow and waveform all
    follow. Sections without tints never call it and are untouched.

    THE CANVAS IS REPAINTED WITH A pointerleave, not a new hook in the player. The
    waveform is drawn once and only redraws on its own events, so after a colour change
    it would sit in the old one until you touched it. ev-kit-audio.js already listens for
    pointerleave and repaints on it, so dispatching one is the whole fix and the player
    keeps its current shape. It also clears any hover line, which is correct here: the
    pointer is over a tab, not over the waveform.  */
(function () {
  'use strict';

  document.querySelectorAll('[data-ev-decks]').forEach(function (deck) {
    var track  = deck.querySelector('[data-ev-deck-track]');
    var panels = Array.prototype.slice.call(deck.querySelectorAll('[data-ev-deck-panel]'));
    var tabs   = Array.prototype.slice.call(deck.querySelectorAll('[data-ev-deck-tab]'));
    if (!track || panels.length < 2) return;

    var root = deck.closest('.ev-kit');
    var i = 0;
    deck.classList.add('is-live');

    function tint (n) {
      if (!root || !tabs[n]) return;
      var c = tabs[n].getAttribute('data-tint');
      if (!c) return;
      root.style.setProperty('--kit-a', c);
      deck.querySelectorAll('[data-ev-viz]').forEach(function (cv) {
        try { cv.dispatchEvent(new Event('pointerleave')); } catch (e) {}
      });
    }

    function show (n) {
      n = Math.max(0, Math.min(panels.length - 1, n));
      if (n === i) return;

      /*  A preview belonging to the folder being left has nothing to stop it once it is
          off screen, so it is stopped here. ev-kit-audio.js owns the player and exposes
          this one hook.  */
      if (window.evKitAudioStop) window.evKitAudioStop();

      i = n;
      track.style.transform = 'translateX(' + (-100 * i) + '%)';
      panels.forEach(function (p, k) { p.classList.toggle('is-on', k === i); });
      tabs.forEach(function (t, k) {
        t.classList.toggle('is-on', k === i);
        t.setAttribute('aria-selected', k === i ? 'true' : 'false');
      });
      tint(i);
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () { show(Number(t.getAttribute('data-ev-deck-tab'))); });
    });

    deck.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { show(i - 1); }
      if (e.key === 'ArrowRight') { show(i + 1); }
    });

    /*  swipe. 44px across and more horizontal than vertical, so a slightly crooked
        scroll down the page is not mistaken for a page turn.  */
    var x0 = null, y0 = null;
    deck.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    deck.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy)) show(dx < 0 ? i + 1 : i - 1);
      x0 = y0 = null;
    }, { passive: true });

    /*  the opening folder's colour, before anything is clicked  */
    tint(0);
  });
})();
